import { ReturnsPreferencesReturnMethodsEnum } from '@/entities/preferences/returns';

import Boxless from './icons/Boxless';
import Printerless from './icons/Printerless';
import BoxWithLabel from './icons/BoxWithLabel';
import Concierge from './icons/Concierge';
import Store from './icons/Store';
import HomePickup from './icons/HomePickup';

export const returnOptions: Array<{
  icon: React.FC;
  title: string;
  key: ReturnsPreferencesReturnMethodsEnum;
}> = [
  {
    title: 'I prefer no box and a digital code (most sustainable)',
    icon: Boxless,
    key: 'boxless',
  },
  {
    title: 'I prefer to use my own box and a digital code',
    icon: Printerless,
    key: 'printerless_mail',
  },
  {
    title: 'I prefer to use my own box and print my own label',
    icon: BoxWithLabel,
    key: 'mail',
  },
  {
    title: 'I prefer to have someone pickup my return from my home',
    icon: HomePickup,
    key: 'home_pickup',
  },
  {
    title: 'I prefer to bring my return to a nearby store',
    icon: Store,
    key: 'store',
  },
  {
    title: 'I prefer to bring my return to a nearby drop-off location',
    icon: Concierge,
    key: 'concierge',
  },
];
